'use client'
import React, { Fragment } from 'react'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { X } from 'lucide-react'
import LoginSlider from './LoginSlider'
import LoginStep1 from './LoginStep1'
import LoginStep2 from './LoginStep2'
import { dispatch, useSelector } from '@/lib/store'
import { useMediaQuery } from '@/hooks/use-media-query'
import { LoginModalProps } from '@/utils/interfaces'
import { resetLoginData } from '@/lib/reducers/loginReducer'

const LoginModal = ({ title, isHeader, maxWidth, open }: LoginModalProps) => {
  const loginState = useSelector((state) => state?.login)
  const { value: isDesktop } = useMediaQuery('(min-width: 768px)')

  const LoginComponent = () => {
    return (
      <Fragment>
        <div className={!isDesktop ? '' : 'flex items-center'}>
          {isDesktop && (
            <div className="w-full">
              <LoginSlider />
            </div>
          )}
          {loginState?.hasOTPSent === false &&
            // !loginState?.phoneNumber &&
            loginState.activeStep === 1 && <LoginStep1 isMobile={!isDesktop} />}
          {loginState?.hasOTPSent === true &&
            !!loginState?.phoneNumber &&
            loginState.activeStep === 2 && <LoginStep2 isMobile={!isDesktop} />}
        </div>
      </Fragment>
    )
  }

  return (
    <div>
      {!isDesktop ? (
        <Drawer open={open} onOpenChange={() => dispatch(resetLoginData())} repositionInputs={false}>
          <DrawerContent
            style={{ maxWidth: maxWidth ? maxWidth : 950 }}
            // onInteractOutside={(e) => {
            //   e.preventDefault()
            // }}
          >
            {(isHeader || title) && (
              <DrawerHeader className="p- flex gap-3 items-center justify-between border-b border-solid border-gray-100">
                <VisuallyHidden.Root>
                  {!!title && (
                    <DrawerTitle className="text-body-lg md:text-heading-md font-bold">
                      {title}
                    </DrawerTitle>
                  )}
                </VisuallyHidden.Root>
                <DrawerClose onClick={() => dispatch(resetLoginData())}>
                  <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center">
                    <X size={18} className="text-gray-800" />
                  </div>
                </DrawerClose>
              </DrawerHeader>
            )}
            <div className={`${!isDesktop ? 'p-4 pt-4' : 'p-6 pt-4'}`}>
              <LoginComponent />
            </div>
          </DrawerContent>
        </Drawer>
      ) : (
        <Dialog open={open} onOpenChange={() => dispatch(resetLoginData())}>
          <DialogContent
            className="p-0 gap-0 modal"
            style={{ maxWidth: maxWidth ? maxWidth : 950 }}
          >
            {isHeader || title ? (
              <DialogHeader className="p-6 border-b border-solid border-gray-100">
                <DialogTitle>{title}</DialogTitle>
              </DialogHeader>
            ) : (
              <VisuallyHidden.Root>
                <DialogTitle>Login</DialogTitle>
              </VisuallyHidden.Root>
            )}
            <div className={`${!isDesktop ? 'px-6' : 'px-6'}`}>
              <LoginComponent />
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  )
}

export default LoginModal
